import { Observable } from 'rxjs/Observable'
import { tokenRevoke } from './authorization'
import { resourcesLoad } from './resources'
import { UNAUTHORIZED } from '../constants/httpStatusCodes'
import { createReducer, removeItemInArray, updateItemInArray } from './reducerUtils'
import moment from 'moment'
import { mergeMap, map, catchError } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { of } from 'rxjs'

// Actions
export const USERINFO_LOAD = 'USERINFO_LOAD'
export const USERINFO_LOAD_SUCCESS = 'USERINFO_LOAD_SUCCESS'
export const USERINFO_LOAD_FAILURE = 'USERINFO_LOAD_FAILURE'

// Action creators
export const userInfoLoad = () => ({ type: USERINFO_LOAD, payload: null })
export const userInfoLoadSuccess = (userInfo) => ({ type: USERINFO_LOAD_SUCCESS, payload: userInfo })
export const userInfoLoadFailure = (error) => ({ type: USERINFO_LOAD_FAILURE, payload: error, error: true })

// Epics
export const userInfoLoadEpic = (action$, state$, { vapiClient }) =>
  action$.pipe(
    ofType(USERINFO_LOAD),
    mergeMap(action =>
      vapiClient.getUserInfo().pipe(
        map(ajaxResponse => userInfoLoadSuccess(ajaxResponse.response)),
        catchError(error => of(getErrorAction(error)))
      )
    )
  )

export const langaugeLoadEpic = (action$, state$) =>
  action$.pipe(
    ofType(USERINFO_LOAD_SUCCESS),
    map((action) => {
      moment.locale(action.payload.locale.cultureInfo)
      return resourcesLoad(action.payload.locale.language)
    })
  )

const getErrorAction = (error) => {
  return (error.status === UNAUTHORIZED)
  ? tokenRevoke()
  : userInfoLoadFailure(error.xhr.response)
}

// Reducer
const userInfoLoadSuccessReducer = (state, userInfo) => userInfo

const userInfoHandlerMapping = {
  [USERINFO_LOAD_SUCCESS]: userInfoLoadSuccessReducer
}

const userInfoInitialState = {}
export const userInfoReducer = createReducer(userInfoInitialState, userInfoHandlerMapping)

export default userInfoReducer



// WEBPACK FOOTER //
// ./src/store/userinfo.js